import { useCallback, useState } from "react";

import { AddressMarker } from "components/CaseMap/AddressMarker";

/**
 * The case's addresses. Deliberately unclustered: a case carries a handful of
 * them at most, and collapsing the one fixed landmark on the map would hide the
 * very thing an analyst measures the machines against.
 */
export function AddressMarkers({ addresses, caseName }) {
  const [openAddressId, setOpenAddressId] = useState(null);

  const handleSelect = useCallback(
    addressId =>
      setOpenAddressId(current => (current === addressId ? null : addressId)),
    []
  );

  const handleClose = useCallback(() => setOpenAddressId(null), []);

  return addresses.map(address => (
    <AddressMarker
      key={`address-${address.id}`}
      address={address}
      caseName={caseName}
      position={{ lat: address.latitude, lng: address.longitude }}
      summaryOpen={address.id === openAddressId}
      onSelect={handleSelect}
      onClose={handleClose}
    />
  ));
}
